module.exports = __webpack_public_path__ + "static/media/deep.bf49a466.jpg";